import React, {useCallback, useState} from 'react';

const useHistory = <T>(): [
  T[],
  React.Dispatch<React.SetStateAction<T[]>>,
  (levels: number) => T | null
] => {
  const [history, setHistory] = useState<T[]>([]);

  const back = useCallback(
    (levels = 1) => {
      const clone = [
        ...history.map(entry => {
          return {
            ...entry,
          };
        }),
      ];

      // remove the last album from the nav history & update its state
      for (let i = 1; i <= levels; i++) {
        clone.pop();
      }

      // clone.pop();
      setHistory(clone);

      if (clone.length > 0) {
        return clone[clone.length - 1];
      }

      return null;
    },
    [history]
  );

  return [history, setHistory, back];
};

export default useHistory;
